import { SUNGAGE_HOSTED_APPLICATION_EYEBROW } from "./sungage-battery-copy"
import { SungageHostedApplication as SharedSungageHostedApplication } from "../../ProposalSetup/financing/sungage/SungageHostedApplication"

/**
 * Hosted Sungage BrightStart borrower application: the shared hosted
 * application with Battery's program name. Closing does not start or cancel
 * anything; resume uses the same server attempt.
 */
export function SungageHostedApplication({
  url,
  onClose,
}: {
  url: string
  onClose: () => void
}): JSX.Element {
  return (
    <SharedSungageHostedApplication
      url={url}
      onClose={onClose}
      eyebrow={SUNGAGE_HOSTED_APPLICATION_EYEBROW}
      testIdPrefix="battery"
    />
  )
}
